const getLivestreamTypeResponse = (response) => {
  return response?.types?.map((item) => {
    return {
      value: item?.value,
      label: item?.label,
    };
  });
};

export default getLivestreamTypeResponse;
